// Login-as (incognito) sessions are marked for the browser tab: the `incognito` query only survives
// the first navigation, so without the mark a reload or a full page load turned the agent's session
// into the customer's (Intercom boot, activity writes, the redirect to elsa-v3). sessionStorage is
// per tab and ends with it. Same key in elsa-v3/src/utils/redesignHandoff.ts.
const LOGIN_AS_SESSION_KEY = 'riseup.loginAsSession';

function isIncognitoQuery(value) {
  return value === true || value === 'true';
}

// The query marks the tab; a later load without it reads the mark.
function resolveIncognito(queryIncognito) {
  try {
    if (isIncognitoQuery(queryIncognito)) {
      sessionStorage.setItem(LOGIN_AS_SESSION_KEY, 'true');
      return true;
    }
    return sessionStorage.getItem(LOGIN_AS_SESSION_KEY) === 'true';
  } catch (error) {
    // Storage unavailable (private mode): the query is all there is.
    return isIncognitoQuery(queryIncognito);
  }
}

// A login of the customer's own (code login, logout) ends the login-as session in this tab.
function clearIncognito() {
  try {
    sessionStorage.removeItem(LOGIN_AS_SESSION_KEY);
  } catch (error) {
    // Storage unavailable: nothing was marked.
  }
}

export default { resolveIncognito, clearIncognito };
